<template>
  <div class="container">
    <h1>Kunde inte hitta sidan</h1>
    <a class="btn btn-link" href="#" @click="goBack()"> &lt;&lt; Tillbaka till föregående sida</a>
  </div>
</template>

<script lang="ts">
	import { defineComponent } from "@vue/runtime-core";

	export default defineComponent({
		name: 'notFound',
		props: {
			returnDepth: {
				type: Number,
				default: 1
			}
		},
    methods: {
      goBack() {
        this.$router.go(-(this.returnDepth ? this.returnDepth : 1))
      }
    }
	});
</script>

<style lang="scss" scoped>
.container {
  border-radius: 8px;
  opacity: 1;
  background-color: rgba(246,246,246, 0.5);
}
</style>